export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#0f7ccf',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: '/sindisantarosa.png',
  favicon: '/cadeadosd.png',
}

export const seo = {
  titulo: 'Senha Digital Soluções Digitais LTDA',
  email: 'suporte@senhadigital.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado curitiba',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: true,
  contaLogin: true,
}

export const contentHome = {
  sispass: true,
  produtorRural: true,
  modalidadesCertificado: true,
  ratingGoogle: false,
}

export const footer = {
  is0800: true,
  telefone: '41 3027 2710 ',
  whatsapp: '4197889062', // Quando cair  --> 4197889062 | 41 99785-3322
  botaoRenocao: '4192848223',
  comercial: '4195227449',
  marketing: '41 2391-4237',
  botaoWhatsapp: '41995227449',
  number0800: '0800 600 2710',
  cidadeuf: 'Curitiba/PR',
  cidade: 'Curitiba',
  bairro: 'Centro',
  titulo: 'Certificado Digital em Curitiba',
  rua: 'Avenida Visconde de Guarapuava',
  numero: '2764',
  complemento: 'sl.405',
  cep: '80010-100',
  cnpj: '19.520.630/0001-15',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Senha Digital',
}

export const redes = {
  facebook: 'https://www.facebook.com/senhadigitaloficial/',
  instagram: 'https://www.instagram.com/senhadigital/',
  linkedin: 'https://www.linkedin.com/company/senhadigitaloficial/mycompany/',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: true,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
